require('./dist/ng-file-upload-all');
module.exports = 'ngFileUpload';

/*** EXPORTS FROM exports-loader ***/
module.exports = "ngFileUpload";


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-file-upload/index.js
 ** module id = 771
 ** module chunks = 2
 **/